import { render, staticRenderFns } from "./DmpZone.vue?vue&type=template&id=358404ca&scoped=true"
import script from "./DmpZone.vue?vue&type=script&lang=js"
export * from "./DmpZone.vue?vue&type=script&lang=js"
import style0 from "./DmpZone.vue?vue&type=style&index=0&id=358404ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358404ca",
  null
  
)

export default component.exports